module.exports = __webpack_public_path__ + "static/media/routing.59e6ff50.svg";